// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"becc2699","625":"becc2699"}[chunkId] + ".chunk.css";
};